import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'

import {
  IConvertedPlayerPrivacySettings,
  IConvertedSlotsLastWinsList,
  IPlayerPrivacySettingsDTO,
  ISlotsLastWinsItemDTO,
} from 'shared/models/LastWins'
import { activeTableTypesSortList } from 'shared/utils/lastWins'

import { IDefaultDataResponse } from '../PaymentApi/types/types'

dayjs.extend(isToday)

export class LastWinsConverter {
  convertSlotsLastWins = (data: IDefaultDataResponse<ISlotsLastWinsItemDTO>): IConvertedSlotsLastWinsList => {
    const wins =
      data?.results?.map(item => ({
        roundId: item.round_id,
        gameId: item.game_id,
        userId: item.max_user_id,
        username: item?.username || '',
        balanceCurrency: item.balance_after_currency,
        provider: item.producer,
        totalBetAmount: item.total_bet_amount,
        multiplier: item.multiplier || '--',
        totalWinAmount: item.total_win_amount,
        date: dayjs(item.max_date).format('hh:mm A'),
        isNickHidden: item.is_nick_hidden,
      })) || []

    return {
      count: data.count,
      page: data.page,
      wins,
    }
  }

  convertPlayerPrivacySettings = (data: IPlayerPrivacySettingsDTO): IConvertedPlayerPrivacySettings => ({
    hideMode: data.player_nick_hide_mode,
    isNickHidden: data.nick_hidden,
    activeTables: data.active_tables?.sort(
      (a, b) =>
        (activeTableTypesSortList.indexOf(a) + 1 || Infinity) -
        (activeTableTypesSortList.indexOf(b) + 1 || Infinity - 1),
    ),
  })
}
